export const NBSP = ' '
export const THINSP = ' '
export const ARROW_UP = '⇑'
export const ARROW_DOWN = '⇓'
